import React from "react";
import "./index.scss";
import { imgArr } from "../../assets/images";

const index = () => {
  return (
    <div className="loader">
      <img src={imgArr.logoIcon} alt="logo" className="loader-icon" />
    </div>
  );
};

export default index;
